<template>
  <LegalPage
    title="Política de privacidad y tratamiento de datos"
    updated-at="30 de agosto de 2026"
    :sections="sections"
  />
</template>

<script>
import LegalPage from './LegalPage.vue';

export default {
  name: 'PrivacyPage',
  components: { LegalPage },
  data() {
    return {
      sections: [
        {
          id: 'responsable',
          title: '1. Responsable del tratamiento',
          paragraphs: [
            'Selk es la responsable del tratamiento de los datos personales que recibimos a través de este sitio web, de nuestros formularios y de los canales de contacto que publicamos (correo electrónico y WhatsApp).',
          ],
        },
        {
          id: 'datos',
          title: '2. Datos que recogemos',
          paragraphs: [
            'Solo pedimos la información necesaria para responder tu solicitud y prestar el servicio:',
          ],
          items: [
            'Datos de contacto: nombre, correo electrónico y, si nos lo compartes, número de WhatsApp o teléfono.',
            'Contenido de tu solicitud: la descripción del proyecto, las observaciones y los datos técnicos de la pieza.',
            'Archivos que subes voluntariamente: modelos 3D (.stl, .ply, .obj) e imágenes o PDF de referencia.',
            'Datos de navegación: información técnica anónima de uso del sitio recogida por herramientas de analítica y publicidad.',
          ],
        },
        {
          id: 'finalidad',
          title: '3. Para qué usamos tus datos',
          paragraphs: [
            'Usamos tus datos para atender tu solicitud, elaborar y enviarte cotizaciones, ejecutar el servicio contratado, hacer seguimiento al proyecto y mantener contigo la comunicación comercial asociada.',
            'No vendemos tus datos ni los compartimos con terceros para fines publicitarios ajenos a Selk.',
          ],
        },
        {
          id: 'conservacion',
          title: '4. Cuánto tiempo los conservamos',
          paragraphs: [
            'Conservamos los datos mientras dure la relación comercial y durante el tiempo adicional necesario para cumplir obligaciones legales, contables y fiscales. Los archivos técnicos que subes se conservan mientras sean necesarios para cotizar o ejecutar el trabajo, y se eliminan a solicitud del titular.',
          ],
        },
        {
          id: 'terceros',
          title: '5. Terceros que intervienen',
          paragraphs: [
            'Para operar el sitio y atender tus solicitudes usamos servicios de terceros que pueden tratar datos por nuestra cuenta:',
          ],
          items: [
            'WhatsApp (Meta Platforms), cuando eliges ese canal para contactarnos.',
            'Google (analítica y publicidad), para medir el uso del sitio y la efectividad de nuestras campañas.',
            'Proveedores de correo y alojamiento necesarios para la operación del sitio.',
          ],
        },
        {
          id: 'derechos',
          title: '6. Tus derechos como titular',
          paragraphs: [
            'De acuerdo con la Ley 1581 de 2012 y sus normas reglamentarias, puedes conocer, actualizar y rectificar tus datos personales; solicitar prueba de la autorización otorgada; ser informado sobre el uso que damos a tus datos; presentar quejas ante la Superintendencia de Industria y Comercio; y revocar la autorización o solicitar la supresión de tus datos cuando no exista un deber legal o contractual de conservarlos.',
            'Para ejercer cualquiera de estos derechos escríbenos al correo de contacto que aparece al final de este documento. Atendemos las solicitudes en los plazos que fija la ley.',
          ],
        },
        {
          id: 'cookies',
          title: '7. Cookies y analítica',
          paragraphs: [
            'Este sitio utiliza cookies y tecnologías similares para recordar preferencias de navegación y medir el uso de las páginas. Puedes bloquearlas o eliminarlas desde la configuración de tu navegador; si lo haces, algunas funciones podrían no comportarse como se espera.',
          ],
        },
        {
          id: 'cambios',
          title: '8. Cambios en esta política',
          paragraphs: [
            'Podemos actualizar esta política para reflejar cambios en nuestros servicios o en la normativa aplicable. Publicaremos la versión vigente en esta misma página, indicando siempre la fecha de última actualización.',
          ],
        },
      ],
    };
  },
};
</script>
